var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar avatar-placeholder"},[(_vm.avatar)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.avatar}}):(_vm.fallback)?_c('div',{staticClass:"fallback",style:(`--background-color: ${_vm.fallbackColor}`)},[_c('span',[_vm._v(_vm._s(_vm.smiley))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }